<script lang="ts">
    import type * as t from "./types";
    import type { Sequence } from "./sequence";

    import eventLogger from "./quiz-event-logger";

    import MultipleChoiceStep from "./MultipleChoiceStep.svelte";
    import EducationalStep from "./EducationalStep.svelte";
    import SegmentResultStep from "./SegmentResultStep.svelte";
    import Step from "./Step.svelte";
    import IntroStep from "./IntroStep.svelte";
    import SegmentsOverviewStep from "./SegmentsOverviewStep.svelte";
    import store from "./quiz-store";
    import { getRelativeStepIdx } from "./utils";

    export let segments: Sequence<t.Segment>;

    function isStepVisible(
        segment: t.Segment,
        globalStepIdx: number,
        stepIdx: number,
    ) {
        const relativeStepIdx = getRelativeStepIdx(segments, globalStepIdx);
        return (
            segment.id === $store.segment.value.id && relativeStepIdx >= stepIdx
        );
    }
</script>

<div></div>

{#each segments.iterate() as segment}
    {#each segment.value.steps.iterate() as node, idx}
        <Step>
            {#if node.value.type === "intro"}
                <IntroStep step={node.value} />
            {:else if node.value.type === "segments_overview"}
                <SegmentsOverviewStep {segments} />
            {:else if node.value.type === "multiple_choice"}
                <MultipleChoiceStep
                    stepIdx={idx}
                    isShowing={isStepVisible(
                        segment.value,
                        $store.globalStepIdx,
                        idx,
                    )}
                    style={node.value.style}
                    options={node.value.options}
                    onSelect={(option) => {
                        eventLogger.logEvent("option_selected", {
                            question: node.value.title,
                            answer: option.title,
                        });
                    }}
                />
            {:else if node.value.type === "educational"}
                <EducationalStep
                    body={node.value.body}
                    visible={isStepVisible(
                        segment.value,
                        $store.globalStepIdx,
                        idx,
                    )}
                    waitUntilCanProceed={node.value.waitUntilCanProceed}
                />
            {:else if node.value.type === "segment_result"}
                <SegmentResultStep node={segment} step={node.value} />
            {/if}
        </Step>
    {/each}
{/each}
